import { Component, Input, OnInit } from '@angular/core';

import { AssignmentBillingPeriodModel } from '../../models/assignment-billing-period.model';

@Component({
    selector: 'app-billed-assignments-period-details',
    templateUrl: './billed-assignments-period-details.component.html',
    styleUrl: './billed-assignments-period-details.component.scss'
})
export class BilledAssignmentsPeriodDetailsComponent implements OnInit {
    @Input({ required: true }) period!: AssignmentBillingPeriodModel;

    constructor() { }

    ngOnInit(): void {

    }

}
